import { getResponsiveScale } from "@core/getResponsiveScale";
import { createContext } from "react";

type GlobalContextType ={
    getRem: (value: number) => number;
}

export const GlobalContext = createContext<GlobalContextType>({
    getRem: (px: number) => getResponsiveScale(px, 0),
});